// @ts-expect-error
import VideoLayout from '../../../modules/UI/videolayout/VideoLayout';
import { CLOSE_ATTACHMENTS, OPEN_ATTACHMENTS, CLOSE_DATISALUTE, OPEN_DATISALUTE, UPDATE_COUNT_ATTACHMENTS, UPDATE_PATIENT_LINK, INVITE_POPUP, HANGUP_CUSTOM, } from './actionTypes';
import { getLocalParticipant } from "../base/participants/functions";
import { closeChat } from "../chat/actions.any";
export * from './actions';
/**
 * Displays the attachments panel.
 *
 * @param {Object} participant - The recipient for the private attachments.
 * @returns {{
 *     participant: Participant,
 *     type: OPEN_ATTACHMENTS
 * }}
 */
export function openAttachments(participant) {
    return function (dispatch) {
        const localId = getLocalParticipant(APP.store.getState())?.id;
        if (typeof APP !== 'undefined') {
            APP.API.notifyAttachmentsOpen(localId, true);
        }
        dispatch({
            participant,
            type: OPEN_ATTACHMENTS
        });
        dispatch(closeChat());
        dispatch(closeDatisalute(participant));
    };
}
/**
 * Action to signal the closing of the attachments dialog.
 *
 * @returns {{
 *     participant: Participant,
 *     type: CLOSE_ATTACHMENTS
 * }}
 */
export function closeAttachments(participant) {
    return function (dispatch) {
        const localId = getLocalParticipant(APP.store.getState())?.id;
        if (typeof APP !== 'undefined') {
            APP.API.notifyAttachmentsOpen(localId, false);
        }
        dispatch({
            participant,
            type: CLOSE_ATTACHMENTS
        });
    };
}
/**
 * Toggles display of the attachments panel.
 *
 * @returns {Function}
 */
export function toggleAttachments() {
    return (dispatch, getState) => {
        const isOpen = getState()['features/attachments'].isOpen;
        if (isOpen) {
            dispatch(closeAttachments());
        }
        else {
            dispatch(openAttachments());
        }
        // Recompute the large video size whenever we toggle the attachments, as it takes attachments state into account.
        VideoLayout.onResize();
    };
}
/**
 * Action to signal the closing of the datisalute dialog.
 *
 * @returns {{
 *     participant: Participant,
 *     type: OPEN_DATISALUTE
 * }}
 */
export function openDatisalute(participant) {
    return function (dispatch) {
        const localId = getLocalParticipant(APP.store.getState())?.id;
        if (typeof APP !== 'undefined') {
            APP.API.toggleDatiSalute(localId, true);
        }
        dispatch({
            participant,
            type: OPEN_DATISALUTE
        });
        dispatch(closeChat());
        dispatch(closeAttachments(participant));
    };
}
/**
 * Action to signal the closing of the datisalute dialog.
 *
 * @returns {{
 *     participant: Participant,
 *     type: CLOSE_DATISALUTE
 * }}
 */
export function closeDatisalute(participant) {
    return function (dispatch) {
        const localId = getLocalParticipant(APP.store.getState())?.id;
        if (typeof APP !== 'undefined') {
            APP.API.toggleDatiSalute(localId, false);
        }
        dispatch({
            participant,
            type: CLOSE_DATISALUTE
        });
    };
}
/**
 * Toggles display of the datisalute panel.
 *
 * @returns {Function}
 */
export function toggleDatisalute() {
    return (dispatch, getState) => {
        const isOpen = getState()['features/datisalute'].isOpen;
        if (isOpen) {
            dispatch(closeDatisalute());
        }
        else {
            dispatch(openDatisalute());
        }
        // Recompute the large video size whenever we toggle the attachments, as it takes attachments state into account.
        VideoLayout.onResize();
    };
}
/**
 * Set attachments count
 *
 * @returns {Function}
 */
export function setAttachmentsCount(count) {
    return (dispatch, getState) => {
        dispatch({
            type: UPDATE_COUNT_ATTACHMENTS,
            count: count
        });
    };
}
/**
 * Set patient link for datisalute
 *
 * @returns {Function}
 */
export function setPatientLink(link) {
    return (dispatch, getState) => {
        dispatch({
            type: UPDATE_PATIENT_LINK,
            link: link
        });
    };
}
/**
 * Open custom invite popup
 *
 * @returns {Function}
 */
export function openInvitePopup() {
    return (dispatch, getState) => {
        const localId = getLocalParticipant(APP.store.getState())?.id;
        if (typeof APP !== 'undefined') {
            APP.API.openInvitePopup(localId);
        }
        dispatch({
            type: INVITE_POPUP
        });
    };
}
/**
 * Hang up custom with popup
 *
 * @returns {Function}
 */
export function hangUpCustom() {
    return (dispatch, getState) => {
        const localId = getLocalParticipant(APP.store.getState())?.id;
        if (typeof APP !== 'undefined') {
            APP.API.hangUpCustom(localId);
        }
        dispatch({
            type: HANGUP_CUSTOM
        });
    };
}
